import { Typography, XStack } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { ReactElement } from 'react'

import type { ExpertBalanceSheetRowKind } from '../../../../types/expertBalanceSheetView'

interface BalanceSheetLabelProps {
  accountNumber?: string
  kind: ExpertBalanceSheetRowKind
  label: string
}

export const BalanceSheetLabel = ({ accountNumber, kind, label }: BalanceSheetLabelProps): ReactElement => {
  if (kind === 'account') {
    return (
      <XStack align="center" gap={4} title={accountNumber ? `${accountNumber} | ${label}` : label}>
        {accountNumber && (
          <>
            <Typography.Text color={colors.content.neutral.medium}>{accountNumber}</Typography.Text>
            <Typography.Text aria-hidden color={colors.content.neutral.soft}>
              |
            </Typography.Text>
          </>
        )}
        <Typography.Text color={colors.content.neutral.medium}>{label}</Typography.Text>
      </XStack>
    )
  }

  const isUppercase = kind === 'subtotal' || kind === 'total'
  const isBold = kind !== 'line'
  const displayLabel = isUppercase ? label.toUpperCase() : label

  return (
    <Typography.Text title={label} weight={isBold ? 'semibold' : 'regular'}>
      {displayLabel}
    </Typography.Text>
  )
}
